import QuotationResultsFcl from "./quotation-results-fcl.component";

export default QuotationResultsFcl;
